import { defineView } from "eddev/views"
import { ContentBlocks } from "eddev/blocks"
import { useSubtheme } from "@hooks/useSubtheme"

export const meta: ViewMeta = {
  templateName: "Data: Transport Affordability",
}

export default defineView("templates/transport-affordability", (props) => {
  useSubtheme("blackHeader")
  return <ContentBlocks blocks={props.page?.contentBlocks} />
})
